import { c as _c } from "react/compiler-runtime";
import { Button, ButtonLink, Icon } from '~/components/primitives';
import ActionRow from '~/components/layout/ActionRow';
import type { Step } from '../';
import { cx } from 'class-variance-authority';
import { useI18n } from '~/features/i18n';
import { useRouter } from 'next/navigation';
import { useState } from 'react';
import { Step_useCtx } from './context';
export default function StepNavigationMenu(props) {
  const $ = _c(4);
  const [isLoading, setIsLoading] = useState(false);
  const i18n = useI18n();
  const stepCtx = Step_useCtx();
  const router = useRouter();
  const prev = stepCtx.getStepByIdx(stepCtx.currentIdx - 1);
  const current = stepCtx.getStepByIdx(stepCtx.currentIdx);
  const next = stepCtx.getStepByIdx(stepCtx.currentIdx + 1);
  const T0 = ActionRow;
  const t0 = "flex justify-end";
  const t1 = prev !== undefined && <ButtonLink className="mr-auto text-brown-700 hover:text-black" variant="link" size="lg" href={prev.href}>{i18n._("Previous step")}</ButtonLink>;
  const t2 = next !== undefined ? <ButtonLink className={cx("w-full md:w-auto", !current?.isCompleted && "cursor-not-allowed! opacity-20", isLoading && "cursor-wait")} variant="tertiary" size="lg" href={next.href} onClick={async e => {
    e.preventDefault();
    if (current?.isCompleted !== true) {
      return;
    }
    setIsLoading(true);
    const shouldAdvance = await props.onStepChange?.(current?.path);
    setIsLoading(false);
    if (shouldAdvance === false) {
      return;
    }
    if ("pathname" in next.href) {
      router.push(next.href.pathname);
    } else {
      const search = new URLSearchParams(window.location.search);
      const newSearch = new URLSearchParams([...search.entries(), ...Object.entries(next.href.query)]);
      router.push(`${window.location.pathname}?${newSearch.toString()}`);
    }
  }}>{isLoading && <Icon name="spinner" size="md" className="animate-spin" />}{i18n._("To step {idx}. {label}", {
      label: next.label,
      idx: next.idx + 1
    })}</ButtonLink> : <Button className="w-full md:w-auto" variant="tertiary" size="lg" isLoading={isLoading} disabled={!stepCtx.state.every(_temp)} onClick={async () => {
    setIsLoading(true);
    const shouldAdvance_0 = current ? await props.onStepChange?.(current?.path) : true;
    if (shouldAdvance_0) {
      await props.onComplete?.();
    }
    setIsLoading(false);
  }}>{props.completeButtonLabel ?? i18n._("Submit request")}</Button>;
  let t3;
  if ($[0] !== T0 || $[1] !== t1 || $[2] !== t2) {
    t3 = <T0 className={t0}>{t1}{t2}</T0>;
    $[0] = T0;
    $[1] = t1;
    $[2] = t2;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  return t3;
}
function _temp(step) {
  return step.isCompleted;
}